module.exports = __webpack_public_path__ + "img/BlinkArt_Sword13_Cyan.506ba6e0.png";